import { useEffect, useState } from 'react';

import { get } from 'js/lib/user';

import { useNaptime } from 'bundles/naptimejs';
import type { ThirdPartyOrganizationsV1 } from 'bundles/naptimejs/resources/__generated__/ThirdPartyOrganizationsV1';
import EnterpriseEventsV1 from 'bundles/naptimejs/resources/enterpriseEvents.v1';

const ENTERPRISE_USE_CONSENT = 'ENTERPRISE_OF_USE_CONSENT';

type EnterpriseEventsNaptimeData = {
  tou?: {
    timestamps?: Array<number>;
  };
};

export const useShowEnterpriseTermsOfUseModal = (thirdPartyOrganization?: ThirdPartyOrganizationsV1) => {
  const userId = get().id;
  const [showTermsOfUseModal, setShowTermsOfUseModal] = useState<boolean>(false);

  const { data: enterpriseEvents, pending: isFetchingEnterpriseEvents } = useNaptime<EnterpriseEventsNaptimeData>(
    () => {
      if (!thirdPartyOrganization || !userId) return {};
      return {
        tou: EnterpriseEventsV1.get(
          `${userId}~organizationEventKey!~${thirdPartyOrganization.id}!!!~${ENTERPRISE_USE_CONSENT}`
        ),
      };
    }
  );

  const requiresEnterpriseTermsOfConsent = Boolean(enterpriseEvents.tou?.timestamps?.length === 0);

  useEffect(() => {
    if (isFetchingEnterpriseEvents) {
      return;
    }
    if (requiresEnterpriseTermsOfConsent) {
      setShowTermsOfUseModal(true);
    }
  }, [isFetchingEnterpriseEvents, requiresEnterpriseTermsOfConsent]);

  return {
    setShowEnterpriseTermsOfUseModal: setShowTermsOfUseModal,
    showEnterpriseTermsOfUseModal: showTermsOfUseModal,
  };
};
